/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react'

import Menu from '../../../components/Menu'

import { useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import foodIcon from '../../../assets/svg/orderIcon.svg'

export default function index() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate()

  document.title = 'سفارشات'

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'order'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={foodIcon} alt='foodIcon' />
              </div>
              <div className='text'>
                سفارشات
              </div>
            </div>

            <div className="left">
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                مشاهده تمامی سفارشات :
              </div>
              <div className="left">
                <button onClick={() => navigate('/orders/all')}>تمامی سفارشات</button>
              </div>
            </div>
            <hr />
            <div className="title">
              <div className="right">
                مشـاهده آمـار سفارشات :
              </div>
              <div className="left">
                <button onClick={() => navigate('/orders/analytics')}>آمــار سفارشات</button>
              </div>
            </div>
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
